import dayjs, { ConfigType } from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';

// 扩展 dayjs 插件
dayjs.extend(utc);
dayjs.extend(timezone);

/**
 * 格式化日期时间（YYYY-MM-DD HH:mm:ss）
 * 自动将输入时间转换为本地时间
 * 
 * @param date 输入日期（ISO 字符串、Date 对象或 dayjs 对象）
 * @returns 格式化后的本地时间字符串
 */
export const formatDateTime = (date: ConfigType): string => {
    if (!date) return '-';
    try {
        return dayjs.utc(date).local().format('YYYY-MM-DD HH:mm:ss');
    } catch (error) {
        console.error('日期解析失败:', error, date);
        return '-';
    }
};

/**
 * 格式化时间（HH:mm:ss）
 * 用于聊天消息等只需要时间的场景
 * 
 * @param date 输入日期
 * @returns 格式化后的本地时间字符串
 */
export const formatTime = (date: ConfigType): string => {
    if (!date) return '-';
    try {
        return dayjs.utc(date).local().format('HH:mm:ss');
    } catch (error) {
        console.error('日期解析失败:', error, date);
        return '-';
    }
};

/**
 * 格式化日期时间（简略版 YYYY-MM-DD HH:mm）
 * 
 * @param date 输入日期
 * @returns 格式化后的本地时间字符串
 */
export const formatDateTimeShort = (date: ConfigType): string => {
    if (!date) return '-';
    try {
        return dayjs.utc(date).local().format('YYYY-MM-DD HH:mm');
    } catch (error) {
        console.error('日期解析失败:', error, date);
        return '-';
    }
};

/**
 * 格式化相对时间（如：今天 12:00, 昨天, 周一, 03-05）
 * 
 * @param date 输入日期
 * @returns 格式化后的本地时间字符串
 */
export const formatRelativeTime = (date: ConfigType): string => {
    if (!date) return '-';
    try {
        const d = dayjs.utc(date).local();
        const now = dayjs();

        if (d.isSame(now, 'day')) {
            return `今天 ${d.format('HH:mm')}`;
        } else if (d.isSame(now.subtract(1, 'day'), 'day')) {
            return '昨天';
        } else if (d.isAfter(now.subtract(7, 'day'))) {
            const weekdays = ['周日', '周一', '周二', '周三', '周四', '周五', '周六'];
            return weekdays[d.day()];
        } else {
            return d.format('MM-DD');
        }
    } catch (error) {
        console.error('日期解析失败:', error, date);
        return '-';
    }
};

export default dayjs;
